<template>
  <div class="active-home-content">
    <ActiveUserBar :back="onBack" />
    <img class="totla_img" :src="`${resBaseUrl}total_bg.png`" alt="" srcset="" />
    <p
      class="totla_amount"
      v-html="$t('envelope.show.amont', { value: formatMoney(animationTotalAmount) })"
    ></p>
    <div class="info-top">
      <div class="info-background">
        <div class="info-title">{{ $t('envelope.title') }}</div>
        <div class="info-money">
          {{ reward ? formatMoney(reward.currentReward) : '--' }} {{ balance.currencyAlias }}
        </div>
        <div class="winnerBox" @click="onShowRule">
          <div
            class="super-simple"
            v-if="reward && reward.superSimple"
            :style="`color: ${depositCollected.length >= 1 ? '#3ea230' : '#6c7e7e'}`"
          >
            <i class="bi bi-person" style="font-size: 0.46rem"></i>Register
          </div>
          <div
            class="super-simple"
            v-if="reward && reward.superSimple"
            :style="`color: ${depositCollected.length >= 2 ? '#3ea230' : '#6c7e7e'}`"
          >
            <i class="bi bi-person" style="font-size: 0.46rem"></i>Register
          </div>
          <i class="bi bi-info-circle-fill"></i>
        </div>
      </div>

      <ShareProgress :width="6" />
      <div class="info-bottom">
        <!-- <div class="bottom-desc">{{ $t('envelope.expiration') }}<br />
                    {{ reward ? formatDate(reward.expiredAt) : '----' }}</div> -->
        <div class="bottom-desc">
          {{ $t('envelope.expiration') }}<br />
          <div class="countdown-wrapper">
            <div class="countdown">
              {{ countdown && countdown.format ? countdown.format('HH') : '--' }}
            </div>
          </div>
          &nbsp;<span style="font-weight: bold">:</span>&nbsp;
          <div class="countdown-wrapper">
            <div class="countdown">
              {{ countdown && countdown.format ? countdown.format('mm') : '--' }}
            </div>
          </div>
          &nbsp;<span style="font-weight: bold">:</span>&nbsp;
          <div class="countdown-wrapper">
            <div class="countdown">
              {{ countdown && countdown.format ? countdown.format('ss') : '--' }}
            </div>
          </div>
        </div>
        <div class="info-button" @click="onWitchDraw">{{ $t('withdraw.title') }}</div>
      </div>
    </div>
    <ActiveMarquee class="marque"></ActiveMarquee>
    <div class="invite-card">
      <InviteIcon
        :inviteIcon="inviteIcon"
        :inviteFriends="inviteFriends"
        :onShare="onShare"
        :depositCollected="depositCollected"
      />
      <div class="link-content">
        <div class="link-url">
          {{ truncateText(shareLink, 28) }}
        </div>
        <div class="link-copy" @click="onCopy">{{ $t('envelope.copy') }}</div>
      </div>
    </div>
    <div class="tab">
      <div
        :class="`tab-item ${select == index ? '' : 'unactive-tab-item'}`"
        :style="
          index == 1
            ? 'border-radius: 0rem 0.16rem 0rem 0rem;'
            : 'border-radius: 0.16rem 0rem 0rem 0rem;'
        "
        v-for="(item, index) in tabs"
        :key="index"
        @click="selectTab(index)"
      >
        <div class="tab-name">
          {{
            index == 0 ? $t('envelope.popup.boosthistory') : $t('envelope.popup.withdrawhistory')
          }}
        </div>
      </div>
    </div>
    <div class="list-content" v-if="select == 0">
      <div class="list-title">
        <div style="width: 40%">{{ $t('envelope.listTitle.time') }}</div>
        <div style="width: 30%">{{ $t('envelope.listTitle.way') }}</div>
        <div>{{ $t('envelope.listTitle.help') }}</div>
      </div>
      <div class="list-scroll">
        <div class="list-item" v-for="(item, index) in listData" :key="index">
          <div class="list-item-content">
            <div style="width: 35%">{{ dayjs(item.time).format('YYYY-MM-DD HH:mm') }}</div>
            <div style="width: 30%">{{ getCollectType(item.collectType) }}</div>
            <div style="width: 30%">{{ formatMoney(item.amount) }} {{ item.currency }}</div>
          </div>
          <div class="list-item-line" />
        </div>
      </div>
    </div>
    <div class="list-content" v-else-if="select == 1">
      <div class="list-title">
        <div style="width: 40%">{{ $t('envelope.listTitle.time') }}</div>
        <div style="width: 30%">{{ $t('envelope.listTitle.way') }}</div>
        <div style="width: 40%">{{ $t('envelope.listTitle.claimed') }}</div>
      </div>
      <div class="list-scroll">
        <div class="list-item" v-for="(item, index) in listData" :key="index">
          <div class="list-item-content">
            <div style="width: 35%">{{ dayjs(item.time).format('YYYY-MM-DD HH:mm') }}</div>
            <div style="width: 30%">{{ item.nickname }}</div>
            <div style="width: 30%">
              {{ formatMoney(item.reward) }} {{ unitConversion(item.currency) }}
            </div>
          </div>
          <div class="list-item-line" />
        </div>
      </div>
    </div>
    <div class="index_banner">
      <Banner :name="'envelop_middle'" />
    </div>
    <div style="font-weight: 700; font-size: 0.3rem !important; color: #ffddac">
      {{ $t('no.tips') }}
    </div>
    <div class="game-content">
      <div class="game" v-if="games.length > 0">
        <div class="game-group" v-for="(row, index) in this.games" :key="index">
          <GameCard
            style="width: 33%"
            v-for="(game, rowIndex) in row"
            :key="rowIndex"
            :game="game"
            :isBig="false"
            height="2.55"
          />
        </div>
      </div>
    </div>
    <EnvelopeBoxComponent v-show="showBox" :updateData="updateData" :inviteUser="inviteUser" />
    <ActiveRewardPopup :show="showRewardPopup" :cancel="() => {}" />
    <ActiveSharePopup :show="showSharePopup" :cancel="() => (showSharePopup = false)" />
    <ActiveWithdrawPopup
      :show="showWithdrawPopup"
      :inviteIcon="inviteIcon"
      :cancel="() => (showWithdrawPopup = false)"
    />
    <ActiveSuccessPopup
      :show="showSuccessPopup"
      :cancel="() => (showSuccessPopup = false)"
      :openNewBox="() => (showBox = true)"
    />
    <ActiveRulePopup :show="showRulePopup" :cancel="() => (showRulePopup = false)" />
    <ActiveBoostList
      :show="showBoostListPopup"
      :cancel="() => (showBoostListPopup = false)"
      :boostList="boostList"
      :onShare="() => onShare({ id: 1 })"
      :onWitchDraw="onWitchDraw"
    />
  </div>
</template>

<script>
import { config } from '@/common/config'
import { getLocalStorage, Key, setLocalStorage } from '@/common/localStorage'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import Banner from '@/components/DhLazyBanner.vue'
import EnvelopeBoxComponent from '@/components/EnvelopeBoxComponent.vue'
import GameCard from '@/components/GameCard.vue'
import ActiveBoostList from '@/components/active/ActiveBoostList.vue'
import ActiveMarquee from '@/components/active/ActiveMarquee.vue'
import ActiveRewardPopup from '@/components/active/ActiveRewardPopup.vue'
import ActiveRulePopup from '@/components/active/ActiveRulePopup.vue'
import ActiveSharePopup from '@/components/active/ActiveSharePopup.vue'
import ActiveSuccessPopup from '@/components/active/ActiveSuccessPopup.vue'
import ActiveUserBar from '@/components/active/ActiveUserBar.vue'
import ActiveWithdrawPopup from '@/components/active/ActiveWithdrawPopup.vue'
import InviteIcon from '@/components/active/InviteIcon.vue'
import ShareProgress from '@/components/active/ShareProgress.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import { getLocale } from '@/locales'
import { useEnvelopeStore } from '@/stores/envelope'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import {
  chunkArray,
  copy,
  currentPage,
  encodeBase64,
  ENV,
  fillterLongID,
  formatDate,
  formatMoney,
  parseUrl,
  setSEO,
  truncateText,
  unitConversion
} from '@/utils/helper'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'pinia'
import { closeToast, showLoadingToast, showSuccessToast } from 'vant'
export default {
  name: 'EnvelopeHome',
  components: {
    ActiveBoostList,
    ActiveRulePopup,
    ActiveSuccessPopup,
    ShareProgress,
    ActiveSharePopup,
    ActiveRewardPopup,
    ActiveWithdrawPopup,
    ActiveUserBar,
    ActiveMarquee,
    EnvelopeBoxComponent,
    Banner,
    GameCard,
    InviteIcon
  },
  props: {
    hasCid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      showResetPassword: false,
      showSelectCountry: false,
      from: '',
      verifyKey: 0,
      showChangePassword: false,
      verifkStep: 1,
      changepasswordKey: 1,
      username: '',
      password: '',
      showCanvas: true,
      animation: null,
      boxStatus: true,
      tabs: [1, 2],
      select: 0,
      listData: [],
      allGame: [],
      games: [],
      progress: 0,
      showRewardPopup: false, // 引导分享
      showSharePopup: false, // 引导分享进度
      showBox: false, // 开宝箱
      showWithdrawPopup: false, // 提现弹窗
      showSuccessPopup: false, // 进度完成领取弹窗
      // canInviteFriends: true, // 前两次分享可以获得奖励 展示相应文案
      inviteFriends: [],
      showRulePopup: false,
      boostList: [], //最新助力列表
      showBoostListPopup: false, //助力增长弹窗
      inviteUser: '', //助力人,
      totleAmount: 0, //当期总领奖金额
      animationTotalAmount: 0, // 金额动画播放值
      inviteIcon: [
        //
        {
          id: 1,
          url: `${config.resBaseUrl}invite-telegram-new.png`,
          name: 'Telegram',
          color: '#29A9EB',
          offX: 0
        },
        {
          id: 2,
          url: `${config.resBaseUrl}invite-facebook-new.png`,
          name: 'Facebook',
          color: '#2973BA',
          offX: 0
        },
        {
          id: 3,
          url: `${config.resBaseUrl}invite-whatsapp-new.png`,
          name: 'Whatapp',
          color: '#4DAD1F',
          offX: 0
        },
        {
          id: 4,
          url: `${config.resBaseUrl}invite-sms-new.png`,
          name: 'SMS',
          color: '#13AEBB',
          offX: 0.2
        }
      ],
      shareLink: `${window.envelopeUrl}/`,
      countdown: null,
      depositCollected: []
    }
  },
  computed: {
    ...mapState(useUserStore, ['isLogin', 'balance', 'userInfo', 'country']),
    ...mapState(useEnvelopeStore, ['reward', 'inviteUserId'])
  },
  watch: {
    isLogin(newValue) {
      if (newValue) {
        console.log('登录信息发生变化，检查红包开启状态')
        this.checkBox()
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'envelophome', to: POPUP.LOGIN, show: false })
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'envelophome', to: POPUP.REGISTER, show: false })
      }
    },
    reward(newValue) {
      if (newValue) {
        const now = dayjs()
        const target = dayjs(newValue.expiredAt)
        this.countdown = dayjs(target.diff(now)).format('HH:mm:ss')
      }
    }
  },
  mounted() {
    this.$bus.$emit(BUS.SHOW_SYSTEM_LOADING, false)
    //解析参数
    const pageParam = parseUrl()
    if (pageParam.has('active')) {
      const token = pageParam.get('active')
      const user = useUserStore()
      if (token && token.length > 0) {
        user.setToken(token)
        this.checkBox()
        this.updateUserInfo()
      } else {
        user.setToken()
        // 未登录弹出登录
        // this.onOpenRegister()
        this.showBox = true
      }
      this.$router.replace('/')
    } else if (!this.isLogin) {
      // 未登录弹出登录
      const invite = getLocalStorage('invite')
      if (!invite || invite == '') {
        // this.onOpenRegister()
        this.showBox = true
      } else {
        if (getLocalStorage('invite') && getLocalStorage('invite') != '') {
          this.inviteUser = getLocalStorage('invite').split('|')[2]
        } else {
          this.inviteUser = ''
        }
        this.showBox = true
      }
    } else {
      //此时已登录，且不是从主站跳转过来的
      this.checkBox()
    }
    this.$bus.$on(BUS.SHOW_ACTIVE_BOX, () => {
      this.showBox = true
    })
    this.gamelist()
    setSEO(currentPage.ACTIVE, this.country)
    setInterval(() => {
      if (this.reward && this.reward.id > 0) {
        const now = dayjs()
        const target = dayjs(this.reward.expiredAt)
        this.countdown = dayjs(target.diff(now))
      }
    }, 1000)
    this.totalClaimedReward().then((r) => {
      this.totleAmount = r.totalReward
      this.animationTotalAmount = 0
      // this.mathTotalAmount()
      window.requestAnimationFrame(this.mathTotalAmount)
    })
    setInterval(() => {
      this.totalClaimedReward().then((r) => {
        this.totleAmount = r.totalReward
        this.animationTotalAmount = 0
        this.mathTotalAmount()
      })
    }, 30000)
  },
  methods: {
    formatDate,
    fillterLongID,
    formatMoney,
    truncateText,
    copy,
    dayjs,
    unitConversion,
    ...mapActions(useLobbyStore, { getGameList: 'getGameList' }),
    ...mapActions(useUserStore, {
      usernameSms: 'usernameSms',
      restPwd: 'restPwd',
      updateUserInfo: 'updateUserInfo'
    }),
    ...mapActions(useEnvelopeStore, {
      updateInvite: 'updateInvite',
      share: 'share',
      domain: 'domain',
      envelope: 'envelope',
      updateReward: 'updateReward',
      collected: 'collected',
      claimed: 'claimed',
      claim: 'claim',
      guide: 'guide',
      latestCollected: 'latestCollected',
      totalClaimedReward: 'totalClaimedReward'
    }),
    mathTotalAmount() {
      // if (this.animationTotalAmount < this.totleAmount) {
      //   this.animationTotalAmount += Math.min(
      //     parseInt(this.totleAmount) / 84,
      //     parseInt(this.totleAmount) - this.animationTotalAmount
      //   )
      // } else {
      this.animationTotalAmount = this.totleAmount
      // }
    },
    onBack() {
      let localHost = {
        ET: 'lobby.megalake.games',
        CI: 'lobby.megalake.games',
        KE: 'lobby.megalake.games'
      }
      if (ENV == 'production') {
        localHost = { ET: 'www.vivagame.et', CI: 'www.vivagame.ci', KE: 'www.vivagame.ke' }
      }
      const localHostName = localHost[this.country]
      window.location.href = 'https://' + localHostName + '?token=' + getLocalStorage(Key.Token)
    },
    onHideResetPassword() {
      this.showResetPassword = false
      if (!this.isLogin) {
        this.onOpenLogin()
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, {
          from: 'changepassword',
          to: POPUP.CHANGE_PASSWORD,
          show: true
        })
      }
      this.username = ''
      this.password = ''
      this.verifyKey++
    },
    onResetPassword(country, password, username, code) {
      return this.restPwd(country, password, username, code).then((response) => {
        if (response) {
          this.onHideResetPassword()
        }
      })
    },
    changeStep(step) {
      this.verifkStep = step
    },
    closeChangePassword() {
      this.changepasswordKey++
      this.$bus.$emit(BUS.SHOW_POPUP, {
        from: 'changepassword',
        to: POPUP.CHANGE_PASSWORD,
        show: false
      })
    },
    onWitchDraw() {
      this.showBoostListPopup = false
      if (this.reward.id == 0) {
        this.checkBox()
        return
      }
      if (this.reward.status == 2) {
        // 完成进度 可领取
        this.claim(this.reward.id).then((res) => {
          console.log(res)
          showSuccessToast({
            message: 'Claim successfully',
            wordBreak: 'break-word',
            duration: 5000
          })
          this.showSuccessPopup = true
          let timer = setTimeout(() => {
            clearTimeout(timer)
            this.$bus.$emit(BUS.SHOW_ENVELOPE_NOTIFY)
          }, 15000)
        })
      } else {
        // 未完成进度
        this.showWithdrawPopup = true
      }
    },
    checkBox() {
      this.envelope().then((res) => {
        if (res.id > 0 && res.status < 3) {
          // 有效红包
          this.showBox = false
          this.updateReward(res)
          this.progress = Math.round((this.reward.currentReward / this.reward.totalReward) * 100)
          this.selectTab(0)
          const shared = getLocalStorage(Key.shared) == 'true'
          if (shared) {
            this.showSharePopup = true
            setLocalStorage(Key.shared, 'false')
          } else {
            this.guide().then((r) => {
              this.showRewardPopup = !r.guide
              if (r.guide) {
                this.latestCollected(res.id).then((r) => {
                  this.boostList = r.records || []
                  if (this.boostList.length == 0) {
                    this.showBoostListPopup = false
                  } else {
                    const addList = this.boostList.filter(
                      (item) =>
                        item.collectType > 1 && item.currency != 'VPS' && item.currency != 'BONUS'
                    )
                    this.showBoostListPopup = addList.length > 0
                  }
                })
              }
            })
          }
        } else {
          // 无有效红包，需要创建，给用户弹获取红包弹窗
          if (getLocalStorage('invite') && getLocalStorage('invite') != '') {
            this.inviteUser = getLocalStorage('invite').split('|')[2]
          } else {
            this.inviteUser = ''
          }
          this.showBox = true
        }
      })
    },
    openBox() {
      if (this.isLogin) {
        if (this.boxStatus) {
          this.boxStatus = false
          if (this.animation) {
            this.animation.stop()
            this.animation.play()
          }
        }
      } else {
        this.onOpenLogin()
      }
    },
    onOpenLogin() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'EnvelopeHome', to: POPUP.LOGIN, show: true })
    },
    onOpenRegister() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'EnvelopeHome', to: POPUP.REGISTER, show: true })
    },
    onShare(item) {
      if (this.reward.id == 0) {
        this.checkBox()
        return
      }
      if (!this.userInfo.username) {
        this.updateUserInfo().then(() => {
          this.onShare(item)
        })
        return
      }
      this.domain().then((res) => {
        if (res.domain && res.domain != '') {
          this.shareLink = res.domain
        }
        this.shareLink +=
          '?id=' +
          encodeBase64(this.reward.id) +
          '&from=' +
          encodeBase64(this.userInfo.username) +
          '|' +
          encodeBase64(this.userInfo.userId) +
          '&lang=' +
          getLocale()
        console.log('shareLink： ===>>>>>>>', this.shareLink)
        this.share(this.reward.id)
          .then((res) => {
            console.log(res)
            // setLocalStorage(Key.shared, 'true')
          })
          .finally(() => {
            switch (item.id) {
              case 1:
                window.location.href = this.telegramLink()
                break
              case 2:
                window.location.href = this.facebookLink()
                break
              case 3:
                window.location.href = this.whatsappLink()
                break
              case 4:
                window.location.href = this.smsLink()
                break
              case 5:
                // eslint-disable-next-line no-case-declarations
                const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
                // eslint-disable-next-line no-case-declarations
                const shareText = [
                  this.$t('envelope.copyshare.share1'),
                  this.$t('envelope.copyshare.share2'),
                  this.$t('envelope.copyshare.share3')
                ][Math.min(randomNum, 2)]
                this.shareLink += '&cid=hbcp&channel=web'
                this.copy(`${shareText} ${this.shareLink}`)
                break
              default:
                break
            }
          })
      })
    },
    telegramLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_index_TG, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.telegram.share1'),
        this.$t('envelope.telegram.share2'),
        this.$t('envelope.telegram.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbtg&channel=web'
      return `https://t.me/share/url?url=${encodeURIComponent(this.shareLink)}&text=${encodeURIComponent(shareText)}`
    },
    facebookLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_index_FB, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.facebook.share1'),
        this.$t('envelope.facebook.share2'),
        this.$t('envelope.facebook.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbfb&channel=web'
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareLink)}&quote=${encodeURIComponent(shareText)}`
    },
    whatsappLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_index_whatapp, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.whatapp.share1'),
        this.$t('envelope.whatapp.share2'),
        this.$t('envelope.whatapp.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbwh&channel=web'
      const message = `${shareText}: ${this.shareLink}`
      return `https://wa.me/?text=${encodeURIComponent(message)}`
    },
    smsLink() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_index_sms, 'click')
      const randomNum = Math.floor(Math.random() * 3) // 生成 0 到 3 的随机整数
      const shareText = [
        this.$t('envelope.sms.share1'),
        this.$t('envelope.sms.share2'),
        this.$t('envelope.sms.share3')
      ][Math.min(randomNum, 2)]
      this.shareLink += '&cid=hbsm&channel=web'
      return `sms:?&body=${encodeURIComponent(shareText + ' ' + this.shareLink)}`
    },
    onCopy() {
      reportGtag(REPORT_EVENT.ENVELOPE.POCKET_MONEY_index_copy, 'click')
      this.onShare({ id: 5 })
    },
    updateData(data) {
      this.showBox = false
      if (data) {
        this.updateReward(data)
        this.progress = Math.round((data.currentReward / data.totalReward) * 100)
        console.log('更新红包数据')
        this.guide().then((r) => {
          this.showRewardPopup = !r.guide
        })
        // this.showRewardPopup = true
      }
    },
    selectTab(index) {
      this.select = index
      this.listData = []
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 0
      })
      if (index == 0 && this.reward) {
        if (this.reward.id == 0) {
          this.checkBox()
          closeToast()
          return
        }
        this.collected(this.reward.id).then((res) => {
          console.log('collected', res)
          this.listData = res.records
          // if (this.listData.length >= 2) {
          //   this.canInviteFriends = false
          // }
          this.inviteFriends = this.listData.filter((item) => item.collectType == 2)
          //过滤充值助力, 超简单红包邀请注册和充值分开计算，累计2次即可领取 by 大壮
          this.depositCollected = this.listData.filter((item) => item.collectType >= 2)
          // const collectedLength = getLocalStorage('collectedLength')
          // if (collectedLength == '' || parseInt(collectedLength) == this.listData.length) {
          //     this.selectTab(1)
          // } else {
          closeToast()
          // }
          setLocalStorage('collectedLength', this.listData.length)
        })
      } else if (index == 1) {
        this.claimed().then((res) => {
          console.log('claimed', res)
          this.listData = res.records
          closeToast()
        })
      } else if (index == 2) {
        this.gamelist()
      }
    },
    gamelist() {
      if (this.hasCid && this.country != 'ET') {
        this.getGameList(0, '', 1, 999)
          .then((response) => {
            this.allGame = response.games
            this.games = chunkArray(response.games, 3, true)
          })
          .catch(() => {
            this.games = []
          })
          .finally(() => {
            closeToast()
          })
      }
    },
    getCollectType(type) {
      let result = ''
      switch (type) {
        case 1:
          result = 'SHARE'
          break
        case 2:
          result = 'REGISTER'
          break
        case 3:
          result = 'DEPOSIT'
          break
        default:
          break
      }
      return result
    },
    onShowRule() {
      this.showRulePopup = true
    }
  }
}
</script>

<style lang="scss" scoped>
.active-home-content {
  width: 100%;
  min-height: 100vh;
  background-color: #2d3e50;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;

  .totla_img {
    height: 1rem;
    margin-top: calc(var(--user-bar-height) + 0.2rem);
  }

  .totla_amount {
    width: auto;
    height: 0.25rem;
    font-family: DroidSans;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.4rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: -0.59rem;
    margin-bottom: 0.3rem;

    .num {
      color: #f1d53a;
      font-family: Oswald-Bold;
      font-weight: bold;
      font-size: 0.24rem;
      line-height: 0.4rem;
    }
  }

  .info-top {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 85%;
    height: 3.4rem;
    // background: linear-gradient(-55deg, #ededed, #e6e6e6, #dbdbdb, #ffffff);
    background: linear-gradient(
      -55deg,
      #8a8a8a,
      #cfcfcf,
      #e4e4e4,
      #c2c2c2,
      #868686,
      #686868,
      #b2b2b2,
      #d5d5d5
    );
    border-radius: 0.16rem;
    // border: 1px solid #95a5a5;
    // margin-top: calc(var(--user-bar-height) + 0.4rem);
    margin-top: 0.15rem;

    .info-background {
      width: 6.4rem;
      height: 1.09rem;
      background: #000000;
      margin-top: 0.3rem;

      .info-title {
        width: auto;
        height: 0.19;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;
        color: #ffffff;
        line-height: 0.4rem;
        margin: 0.05rem 0 0 0.4rem;
      }

      .info-money {
        width: auto;
        margin: 0.1rem 0 0 0.4rem;
        height: 0.51rem;
        font-family: Oswald;
        font-weight: bold;
        font-size: 0.5rem;
        color: #8fc31f;
        line-height: 0.4rem;
        background: linear-gradient(
          0deg,
          #fff476 10.302734375%,
          #e4a900 49.755859375%,
          #ffc600 50%,
          #fbeabd 90.2099609375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .winnerBox {
        font-size: 0.38rem;
        color: #ceb45f;
        position: absolute;
        display: flex;
        margin: 0px;
        padding: 0px;
        right: 0.7rem;
        top: 2.8rem;
        flex-direction: row;
        width: auto;
        flex-direction: row;

        .super-simple {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 0.2rem;
          color: #6c7e7e;
          margin-top: -0.2rem;
          margin-left: 0.1rem;
        }
      }
    }

    .progress {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 5.59rem;
      height: 0.48rem;
      background: #211d28;
      border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
      margin-top: 0.3rem;

      .bar {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        width: 4.04rem;
        height: 0.4rem;
        background: #009944;
        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
        margin-left: 0.04rem;

        .desc {
          min-width: 5rem;
          height: 0.4rem;
          font-size: 0.24rem;
          line-height: 0.4rem;
          color: #ffffff;
          border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
          margin-left: 0.2rem;
          // border: 0.02rem solid #ffffff;
        }
      }
    }

    .info-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 5.59rem;

      .bottom-desc {
        width: 2.36rem;
        height: 0.39rem;
        font-family: DroidSans;
        font-size: 0.18rem;
        color: #404040;
        line-height: 0.24rem;
        text-align: left;
        font-style: normal;
        text-transform: none;

        .countdown-wrapper {
          position: relative;
          display: inline-block;

          .countdown {
            font-size: 0.24rem;
            font-weight: normal;
            color: #000;
            padding: 0.02rem;
            // text-shadow: 0.02rem 0.02rem 0.04rem #000000;
            border: 0.02rem solid #000;
            border-radius: 0.06rem;
          }
        }
      }

      .info-button {
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 0.16rem;

        // height: 0.2rem;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;
        color: #ffffff;
        margin: 0.29rem 0 0 0;
        box-shadow:
          0rem 0rem 0rem 0rem #266aac,
          0rem 0rem 0rem 0rem #266aac;

        width: 2.36rem;
        height: 0.8rem;
        background: #336aea;
        border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
      }
    }
  }

  .marque {
    margin-top: 0.2rem;
    background-color: #000;
    height: 0.53rem;
  }

  .invite-card {
    width: 6.4rem;
    height: auto;
    padding-bottom: 0.3rem;
    background: #f1f1f1;
    border-radius: 0.16rem;
    border: 1px solid #f1f1f1;
    margin-top: 0.2rem;

    .link-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.24rem;
      margin-top: 0.5rem;

      .link-url {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 0.3rem;
        width: 3.55rem;
        height: 0.7rem;
        background: #ffffff;
        border-radius: 0.16rem;
        border: 0.01rem solid #95a5a5;
        margin-left: 0.4rem;

        font-family: Droid Sans;
        font-weight: 400;
        color: #9ca0ab;
        line-height: 0.22rem;
      }

      .link-copy {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.3rem;
        height: 0.7rem;
        background: #336aea;
        border-radius: 0.16rem;
        margin-left: 0.3rem;
        margin-right: 0.5rem;
      }
    }
  }

  .tab {
    display: flex;
    // flex-direction: row;
    justify-content: space-around;
    align-items: flex-end;
    width: 88%;
    height: 1rem;
    background: #2d3e50;
    margin-top: 0.1rem;
    padding-left: 6%;
    padding-right: 6%;

    .tab-item {
      display: flex;
      justify-content: center;
      align-content: center;
      width: 50%;
      height: 0.4rem;
      padding: 0.1rem 0.2rem;
      background: #ffffff;
      // border-radius: 0.16rem 0.16rem 0px 0px;
      // border-radius: 0.16rem 0rem 0rem 0rem;

      .tab-name {
        text-align: center;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;
        color: #1a1a1a;
        line-height: 0.4rem;
        height: 0.26rem;
      }
    }

    .unactive-tab-item {
      background: #778989;
      color: #2d3e50;
    }
  }

  .list-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 4rem;
    // overflow: auto;
    background: #2d3e50;

    .list-title {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 80%;
      height: 0.48rem !important;
      background: #bbc2ca;
      border-radius: 0.24rem;
      margin-top: 0.23rem;
      font-size: 0.24rem;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      color: #32333d;
      font-weight: bold;
    }

    .list-scroll {
      width: 100%;
      height: calc(4rem - 0.48rem);
      overflow-x: hidden;
      overflow-y: auto;

      .list-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-left: 3%;

        .list-item-content {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 90%;
          height: 0.48rem;
          margin-top: 0.23rem;
          font-size: 0.24rem;
          padding-left: 0.2rem;
          padding-right: 0.2rem;
          color: #ffffff;
          font-weight: 400;
        }

        .list-item-line {
          width: 88%;
          height: 1px;
          margin-left: 3%;
          background-color: #ffffff;
        }
      }
    }
  }

  .index_banner {
    margin: 0.2rem 0;
    padding: 0;
    min-height: 1.5rem;
    width: 100%;
    overflow: hidden;
    // margin-top: 0.24rem;
  }

  .game-content {
    display: flex;
    width: 100%;
    height: auto;
    justify-content: center;
    flex-direction: column;
    padding-top: 0.2rem;
    // margin-bottom: 0.5rem;

    .game {
      display: flex;
      flex-direction: column;

      .game-group {
        display: flex;
        flex-direction: row;
        margin-left: -0.05rem;
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
